import { useAppDispatch } from '../../../app/hooks';
import { toggleDepositUlxModal } from '../../../slices/portfolio-slice';
import { CaptionText, H1, H3 } from '../../../styles/FontStyles';
import { lightTheme } from '../../../styles/GlobalStyles';
import { Button } from '../../../components';
import { useHistory } from 'react-router-dom';
import { MY_HUBS_AKASHA } from '../../../routes/routes';

export const Step3 = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  return (
    <>
      <H1 center mb='20'>
        &#9989;{' '}
      </H1>{' '}
      <H3 mb='8' semiBold center caps>
        Deposit request sent
      </H3>
      <CaptionText mb='20' center color={lightTheme.colors.neutral500}>
        Your deposit request has been sent to the blockchain for processing. The
        processing time depends on the congestion of the blockchain network. It
        may take up to an hour for your transaction to be processed.
      </CaptionText>
      <Button
        mt='20'
        onClick={() => {
          dispatch(toggleDepositUlxModal(false));
          history.push(MY_HUBS_AKASHA);
        }}>
        Continue
      </Button>
    </>
  );
};
